import React from "react"
import { Form } from "react-bootstrap"
import { injectIntl } from "react-intl"
import { LabelInputFormGroupProps } from "../types/labelInputFormGroup"

const LabelInputFormGroup = ({ formLabel, inputProps, children }: LabelInputFormGroupProps) => {
    return <Form.Group>
        <Form.Label htmlFor="labelInputGroup" className="custom-form-label">
            { formLabel }
        </Form.Label>
        <Form.Control
            {...inputProps}
        />
        {children}
    </Form.Group>
}

export default injectIntl(LabelInputFormGroup)


// WEBPACK FOOTER //
// ./src/common/form/LabelInputFormGroup.tsx